import React, { Component } from 'react';
import { DealHistory } from './DealHistory';
import { RtiList } from './RtiList';
import { RtiDtlAp } from './RtiDtlAp';
import { HeaderSub2 } from '../../Common/HeaderSub2';
import { HeaderSub } from '../../Common/HeaderSub';
import { Footer } from '../../Common/Footer';

import { Big3Common } from '../../../js/IncludeManager'
/* 개발담당:양유빈
 * 화면기능: 내거래처 메인
 * 세부설명: 내거래처 리스트, 거래처 거래내역 화면 전환
*/
export class Index extends Component {
    static displayName = Index.name;
    constructor(props) {
        super(props);
        this.state = {
            RenderName: this.CompName.RtiList,   
            ContentState: null,
            ComponentUrl:"RtiList"
        };
    }
    CompName = {
        "DealHistory": "DealHistory",
        "RtiList": "RtiList",
        "RtiDtlAp":"RtiDtlAp"
    }
    //초기화
    componentDidMount() {
    }
    componentWillUnmount() {
        Big3Common.HistoryBackToClearBackdoor();
    }
    renderPick() {
        
        if (this.state.RenderName === this.CompName.RtiList) {
            return (
                <div>
                    <HeaderSub2
                        HeaderTitle="거래처"
                        HistoryBack={true}
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                        ComponentName={this.state.RenderName}
                    />
                    <RtiList
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState, ComponentUrl: "RtiList" })}
                        ContentState={this.state.ContentState}
                    />
                    <Footer
                        fillName="icon1"
                        ComponentName={this.state.RenderName}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.DealHistory) {
            //ComponentUrl의 경로가 리스트, 상세 에서 달라지기 때문에 state에 할당해서 처리
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="거래내역"
                        ComponentUrl={this.state.ComponentUrl}
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                        ComponentName={this.state.RenderName}
                    />
                    <DealHistory
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.RtiDtlAp) {
            return (
                <div>
                    <HeaderSub
                        ComponentUrl="RtiList"
                        HeaderTitle="거래처 정보"
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                        ComponentName={this.state.RenderName}
                    />
                    <RtiDtlAp
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState,ComponentUrl: "RtiDtlAp" })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }

    }  
    render() {
        let RnderAct = this.renderPick();
        return (
            <div>
                {RnderAct}
            </div>
        );
    }
}
